export default {
  api: {
    // Stored in global for quicker access without asynchronicity
    accessToken: '',
    expirationTimestamp: null,
  },
};
